/**
 * Cart Drawer: Continue Shopping button fix - SeaMonster Studios
 * Horizon theme — 0fec68-eb.myshopify.com
 *
 * Problem: clicking the "Continue shopping" button in the empty cart
 * drawer does not close the drawer or scroll to the #order section.
 *
 * Fix: intercept the click, close the drawer via the custom element's
 * .close() method, then handle the /#order anchor scroll.
 *
 * HOW TO ADD THIS TO YOUR THEME
 * ─────────────────────────────
 * Option A (recommended): Paste the contents of the <script> block below
 * into your theme's layout/theme.liquid, just before the closing </body> tag.
 *
 * Option B: Upload this file to your theme's Assets folder, then include
 * it in layout/theme.liquid with:
 *   <script src="{{ 'cart-continue-shopping.js' | asset_url }}" defer></script>
 */

(function () {
  'use strict';

  /**
   * Close the Horizon cart drawer using the custom element's built-in method.
   */
  function closeCartDrawer() {
    var cartDrawer = document.querySelector('cart-drawer-component');
    if (cartDrawer && typeof cartDrawer.close === 'function') {
      cartDrawer.close();
    }
  }

  /**
   * Scroll smoothly to the #order section on the current page.
   * Falls back to setting window.location.hash if the element isn't found.
   */
  function scrollToOrder(hash, delay) {
    setTimeout(function () {
      var target = document.getElementById(hash.replace('#', ''));
      if (target) {
        target.scrollIntoView({ behavior: 'smooth', block: 'start' });
        // Update the URL bar without triggering a reload
        history.replaceState(null, '', hash);
      } else {
        // Section may use a Shopify section ID — fall back to hash navigation
        window.location.hash = hash;
      }
    }, delay || 0);
  }

  /**
   * Listen for clicks anywhere in the document.
   * Only acts when the click target is (or is inside) the "Continue shopping"
   * button, identified by its class .cart-items__empty-button.
   */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('.cart-items__empty-button');
    if (!btn) return;

    var href   = btn.getAttribute('href') || '';
    var hash   = href.indexOf('#') !== -1 ? '#' + href.split('#')[1] : '';
    var isHome = window.location.pathname === '/' || window.location.pathname === '';

    // Always close the drawer first
    e.preventDefault();
    closeCartDrawer();

    if (isHome && hash) {
      // Already on the homepage — scroll after a short delay so the
      // drawer close animation has time to finish
      scrollToOrder(hash, 350);
    } else if (hash) {
      // On a different page — navigate to the homepage anchor
      window.location.href = '/' + hash;
    } else if (href) {
      // No hash, just navigate normally
      window.location.href = href;
    }
  });

})();
